import React from 'react';
import classnames from 'classnames';
import baseStyles from 'custom/base.styl';

const SubjTestOverview = (props) => {
  const count = 15;
  const minutes = 15;

  return (
    <div>
      <p className={classnames(baseStyles.title_extra_small, baseStyles.mb_30)}>
        Almost halfway there! Do not stop, nail this test, and move to the last stage of our testing environment! Earning money from home can be that easy.
      </p>
      <p className={classnames(baseStyles.succeess_title, baseStyles.mb_15, baseStyles.left)}>Subject test will take up to {minutes} minutes of your time:</p>
      <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__dark)}>
        <li>There are <b>{count}</b> multiple choice questions.</li>
        <li><b>Only one</b> answer is correct.</li>
        <li>You will <b>not be able to either pause or restart</b> the test.</li>
        <li>You will need to <b>answer all the questions</b> before the time runs out.</li>
      </ul>
    </div>
  );
};

export default SubjTestOverview;



// WEBPACK FOOTER //
// ./src/components/ApplicationOverview/SubjectTestOverview.js